import ReactSelect from 'react-select';

import Heading from '../Typography/Heading';
import Paragraph from '../Typography/Paragraph';

interface SelectProps {
  ariaLabel?: string;
  errorMsg?: string | null;
  id?: string;
  label?: string;
  options: { label: string; value: string }[];
  setState: React.Dispatch<
    React.SetStateAction<{ label: string; value: string }>
  >;
  value: { label: string; value: string };
}

const Select: React.FC<SelectProps> = ({
  ariaLabel,
  errorMsg,
  id,
  label,
  options,
  setState,
  value,
}) => {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id}>
          <Heading level="h5" text={label} />
        </label>
      )}
      <ReactSelect
        aria-label={ariaLabel ?? label ?? ''}
        className="text-base text-black font-bold border-2 border-black rounded-theme p-1"
        id={id}
        options={options}
        onChange={(e) => {
          setState(e as { label: string; value: string });
        }}
        styles={{
          control: (styles) => ({
            ...styles,
            boxShadow: 'none',
            border: 'none',
            outline: 'none',
          }),
        }}
        value={value}
      />
      {errorMsg && (
        <Paragraph color="text-red" style="text-sm" text={errorMsg} />
      )}
    </div>
  );
};

export default Select;
